import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import ContentPageHero from '../components/ContentPageHero';
import Blog from '../components/Blog';
import Footer from '../components/Footer';

const BlogPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Blog | PH Therapy</title>
        <meta name="description" content="Articles on exercise physiology, MSK, oncology, cardiac care, and lifestyle management. Evidence-based insights from PH Therapy clinicians." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/blog" />
      </Helmet>
      <Header />
      <ContentPageHero
        title="Our Blog"
        description="Evidence-based insights on exercise physiology, MSK rehabilitation, oncology care, cardiac health, and lifestyle management from PH Therapy clinicians."
      />
      <Blog />
      <Footer />
    </>
  );
};

export default BlogPage;